import Phaser from 'phaser';
import RoundedButton from '../buttons/RoundedButton.js';
import { Colors } from '../../consts/Colors.js';
import { Fonts } from '../../consts/Fonts.js';
import { tags } from '../../consts/Tags.js';

export default class Popup extends Phaser.GameObjects.Container {
    constructor(scene, x, y, {width = 1004, height = 452, text}) {
        super(scene, x, y, []);

        scene.add.existing(this);
        this.scene = scene;

        // Ajout fond
        const background = this.scene.add.rexRoundRectangle(0, 0, width, height, 47, Colors.Elmt.White).setOrigin(0.5);
        this.add(background);

        // Ajout texte
        const textElmt = this.scene.add.rexTagText(0, 0, text, {
            fontSize: '32px',
            fontFamily: Fonts.MassiliaBold,
            align: 'center',
            color: Colors.Text.DarkBlue,
            backgroundColor: 'transparent',
            wrap: {
                mode: 'word',
                width: width - 160
            },
            resolution: 2,
            tags: tags
        }).setOrigin(0.5, 0);
        this.add(textElmt);

        // Ajout bouton
        this.introBtn = new RoundedButton(this.scene, 0, textElmt.y + textElmt.height + 40, { 
            width: 212, 
            height: 50,
            text: "Commencer", 
            textColor: Colors.Text.White, 
            backgroundColor: Colors.Elmt.DarkBlue,
            hoverBackgroundColor: Colors.Elmt.Orange,
            fontSize: '24px',
        });
        this.introBtn.y += this.introBtn.height / 2;
        this.add(this.introBtn);


        // Ajustement de la position du texte et du bouton
        const totalHeight = textElmt.height + 40 + this.introBtn.height;
        textElmt.y = -totalHeight / 2;
        this.introBtn.y = textElmt.y + textElmt.height + 40 + this.introBtn.height / 2;

        // Ajustement de la taille du fond en fonction du texte et du bouton
        const padding = 80;
        background.setSize(width, totalHeight + padding);
    }

    setClickFunction(clickFunction) {
        this.introBtn.setClickFunction(() => {
            clickFunction(this);
        })
    }

    show(){
        this.setAlpha(0)
        this.y += 50
        this.scene.tweens.add({
            targets: this,
            alpha: 1,
            y: '-=50',
            duration: 300,
        })
    }

    hide(endFunc = null){
        this.scene.tweens.add({
            targets: this,
            alpha: 0,
            y: '+=50',
            duration: 300,
            onComplete: () => {
                if (endFunc) {
                    endFunc();
                }
                this.destroy()
            }
        })
    }
}